import {Resource} from "./resource";
import {DeploymentResource} from "./deploymentResource";
import {TaskResource} from "./taskResource";

export interface LifecycleProgressionResource extends Resource {
    Phases: PhaseProgressionResource[];
    NextDeployments: string[];
    NextDeploymentsMinimumRequired: number;
}

export interface PhaseProgressionResource {
    Id: string;
    Name: string;
    Blocked: boolean;
    Progress: PhaseProgress;
    Deployments: PhaseDeploymentResource[];
    AutomaticDeploymentTargets: string[];
    OptionalDeploymentTargets: string[];
    MinimumEnvironmentsBeforePromotion: number;
    IsOptionalPhase: boolean;
}

export enum PhaseProgress {
    Pending = "Pending",
    Current = "Current",
    Complete = "Complete"
}

export interface PhaseDeploymentResource {
    Task: TaskResource<any>;
    Deployment: DeploymentResource;
}

export default LifecycleProgressionResource;


// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--1!./app/client/resources/lifecycleProgressionResource.ts